module.exports = __webpack_public_path__ + "static/media/Status_Gris.597aabdb.svg";